// Generated i18n file
export default {
  title: '東京Metro・都營地下鐵共通1日乘車券',
  notes: {
    item1:
      '同時購買多張乘車券時,可在使用開始前透過社群軟體等方式分配至各自的智慧型手機。',
    item2: '如需在1台裝置上使用多張QR Code時,請務必讓持有憑證的客人最後通過。',
    description2:
      '※通過檢票機所需時間將比平時更長,可能無法搭乘您期望的列車,敬請預留充裕時間使用。',
    item3: '本乘車券不適用於搭乘東京Metro線及都營地鐵線以外的路線。',
    item4: '列印出的QR Code或截圖無法使用。',
    description4:
      '※若因智慧型手機等裝置遺失或電量耗盡等原因導致無法透過畫面確認本乘車券的有效性時,將視同未持有乘車券,需支付包含本乘車券有效區間在內的實際乘車區間的規定運費。車站恕不提供充電等服務,敬請提前知曉。',
    item5:
      '超過乘車券有效期間及有效期限後將無法使用。(即使按下使用開始按鈕,如當日末班車前未在自動檢票機等使用,亦無法使用。)',
    item6:
      '僅限在有效期間內且使用開始前,可在購買歷史記錄頁面辦理退款,每筆交易(每次支付)將產生220日圓的退款手續費。',
    item7: '出示有效乘車券畫面即可享受換乘運輸服務。',
    item8:
      '關於QR Code乘車券無法使用等疑問,請在郵件中註明「預約號碼」和「姓名」,聯絡購買方。',
    description8: 'QR Code是DENSO WAVE INC.的註冊商標。',
    title: '注意事項'
  },
  explain: {
    description:
      '在使用日當天,從首班車到末班車,可自由乘坐東京Metro全9條路線和都營地下鐵全4條路線的乘車券。',
    title: '使用說明',
    area: '使用區間',
    areaValue: '東京Metro全線及都營地下鐵全線',
    howToUse: '使用方法',
    step1: {
      alt: '購買QR Code數位車票',
      description:
        '① QR Code乘車券是透過智慧型手機提前購買QR Code數位車票,在自動檢票機上掃描QR Code即可使用的服務。'
    },
    step2: {
      alt: '按下使用開始按鈕',
      description: '② 可在支援QR Code的檢票口進出。',
      tip: '※在不支援QR Code的檢票口,請向檢票口的站務員諮詢。如站務員不在,請透過檢票口的對講機呼叫站務員。'
    },
    step3: {
      alt: '在支援QR Code的檢票口進出',
      description:
        '③ 使用前請務必按下「使用開始」按鈕進行入場處理。按下「使用開始」按鈕後使用期間即開始,將無法退款。請務必在使用前按下按鈕。'
    },
    validityDescription:
      '自購買後90天內的任意一天中，自點擊「使用開始」鈕當天首次進站起至末班車前有效。',
    validityNotice: '※點擊使用開始紐後若未於當日末班車前使用，該票即告失效。',
    validityTitle: '有效期間或有效期限'
  },
  faq: {
    title: '常見問題',
    faqList: [
      {
        answer: `透過一部智慧型手機即可無現金購買和使用的划算車票。
您手機上顯示的QR Code和動畫可以代替車票使用。
銷售以下票種。
・Tokyo Subway 24/48/72-Hour Ticket(QR)
・東京Metro都營地鐵共通1日乘車券(QR)
・東京Metro 24小時券(QR)
`,
        question: '什麼是QR Code企劃乘車券?'
      },
      {
        answer: `請在專用網站使用「Google」或「Email」帳號登入後,選擇數位車票種類,用信用卡支付。
※請用半形羅馬字輸入註冊姓名。`,
        question: '如何購買?'
      },
      {
        answer: 'VISA、MasterCard、JCB、American Express、Diners',
        question: '信用卡支付可使用哪些信用卡?'
      },
      {
        answer: `信用卡公司需要3D Secure認證。
包括設定在內,如無法使用信用卡支付,請向信用卡公司諮詢。`,
        question: '無法使用信用卡支付時怎麼辦?'
      },
      {
        answer: `QR Code企劃乘車券必須持有智慧型手機等資訊終端才能使用。另外,無法使用螢幕截圖。`,
        question: '沒有智慧型手機能否使用QR Code企劃乘車券?'
      },
      {
        answer: `【年齡區分】
・成人(12歲以上)
  成人運費。但是,13歲以下的小學生適用兒童運費。
・兒童(6歲以上12歲未滿)
  兒童運費。但是,6歲尚未入小學的按幼兒計算。
`,
        question: '乘車券的年齡區分是?'
      },
      {
        answer: `代表者為多人一起購買並使用QR Code企劃乘車券時,如同時購買多張,請在使用開始前透過社群軟體等分配至各自的智慧型手機。如不分配而用1台裝置使用多張乘車券,通過檢票機所需時間將比平時更長,可能無法搭乘您期望的列車,敬請預留充裕時間使用。
用1台裝置使用多張QR Code企劃乘車券通過自動檢票機時,請務必讓持有憑證的客人最後通過。
`,
        question: '什麼是乘車券分配功能?'
      },
      {
        answer:
          'QR Code企劃乘車券使用日(乘車日)按下「使用開始」按鈕後,如當日末班車前未使用自動檢票機,乘車券將變為無效。請務必在乘車日首班車時間之後按下「使用開始按鈕」。通過自動檢票機時刻起開始計算數位車票的有效期限。',
        question: '乘車券畫面上的「使用開始」是什麼意思?'
      },
      {
        answer:
          '部分車站的檢票口沒有支援QR Code企劃乘車券的自動檢票機。請向檢票口的站務員諮詢。乘車或下車時需要在站務設備上進行處理。另外,對於站務員不在的檢票口,請透過對講機等呼叫站務員。如距離站務室較遠,可能需要等待站務員到達,敬請預留充裕時間使用。',
        question: '如果沒有支援QR Code企劃乘車券的檢票機怎麼辦?'
      },
      {
        answer: `僅限在有效期間內且使用開始前的乘車券,可在銷售網站上辦理退款。(每次支付收取220日圓退款手續費)
購買多張QR Code企劃乘車券辦理退款時,無法退款部分乘車券,將全部乘車券一起退款,敬請注意。`,
        question: '能否辦理退款?'
      },
      {
        answer: `如因智慧型手機等資訊終端遺失或電池耗盡等導致站務員無法確認QR Code企劃乘車券畫面資訊,將視為您未持有有效乘車券,需以現金或IC卡支付實際乘車區間的規定運費。請注意終端的充電狀況。車站恕不提供充電等服務,敬請提前知曉。`,
        question: '使用中智慧型手機故障或電源耗盡時該怎麼辦?'
      },
      {
        answer: '如能出示有效乘車券,即為換乘運輸對象。',
        question: '是否為換乘運輸對象?'
      },
      {
        answer: `請聯絡郵件諮詢聯絡方式。
郵箱地址 helpcenter@linktivity.co.jp
`,
        question: '購買後未收到確認郵件怎麼辦?'
      },
      {
        answer:
          '購買後或使用開始後無法使用QR Code企劃乘車券等疑問,請在郵件中註明「預約號碼」和「姓名」,聯絡購買方。',
        question: '無法使用QR Code企劃乘車券時怎麼辦?'
      }
    ]
  },
  ticket: {
    buy: '購買',
    qrcode: {
      desc: '使用QR Code',
      title: '東京Metro・都營地下鐵共通1日乘車券'
    },
    ticketLink: {
      qrcode:
        'https://tokyometrods.triplabo.com/zt/product/prod_agptukaojvyvpju53rrbt4kqqe?utm_source=metro-toei-pass.triplabo.jp&utm_medium=referral&utm_campaign=v3_migration&utm_content=metro_toei_pass_all_languages'
    }
  }
};
